(ns iris.search.events
  (:require
   [re-frame.core :as re-frame]
   [iris.events :as events]))

(re-frame/reg-event-db
 ::clear-header-search
 (fn [db]
   (assoc db :header-search {:data [] :meta nil})))

(re-frame/reg-event-db
 ::clear-header-search-meta
 (fn [db]
   (assoc-in db [:header-search :meta] nil)))

(re-frame/reg-event-db
 ::header-search-success
 [(events/api-msg-interceptor {:id :header-search-success-api-msg-interceptor})]
 (fn [db [_ data]]
   (re-frame/dispatch [::events/set-loading false])
   (-> db
       (assoc-in [:header-search :data] (or (get-in data [:result :data]) []))
       (assoc-in [:header-search :meta] (get-in data [:result :meta])))))

(re-frame/reg-event-db
 ::header-search-failure
 [(events/api-msg-interceptor
   {:id :header-search-failure-api-msg-interceptor
    :debug-message-modifier-fn (fn [msg] (str "Header search API failure: " msg))})]
 (fn [db]
   (re-frame/dispatch [::events/set-loading false])
   db))

(re-frame/reg-event-fx
 ::header-search
 (fn [{:keys [db]} [_ {:keys [q ws limit page]}]]
   (merge
    {:db (assoc-in db [:header-search :meta] nil)}
    (events/post-rpc {:jsonrpc "2.0"
                      :id 0
                      :method "Header.Search"
                      :params {:data {:limit (int limit)
                                       :number_found_accuracy 500
                                       :page (int page)
                                       :q q
                                       :ruids_only false
                                       :ws ws}
                               :options {:debug false}}}
                     [::header-search-success]
                     [::header-search-failure]))))
